// extracted by css-extract-rspack-plugin
export default {"secret":"secret-r4s75v"};